/* eslint-disable react/no-children-prop */
import { IconButton, Tooltip } from '@chakra-ui/react';
import { PencilSimpleLine } from 'phosphor-react';
import React from 'react';

export const EditButton = ({ onClick }: any) => {
  return (
    <Tooltip label="Editar" openDelay={300}>
      <IconButton
        onClick={onClick}
        color="content.subtle"
        icon={<PencilSimpleLine size={16} />}
        size="xs"
        mr="2px"
        variant="ghost"
        _hover={{ bg: 'surface.selected', color: 'content.strong' }}
        aria-label="Editar"
      />
    </Tooltip>
  );
};
